import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function searchOrders(qryConds) {
  return Vue.http.get(api + 'sales/list',{params:qryConds})
}

export function getOrderInfo(scode){
  return Vue.http.get(api + 'sales/info/' + scode)
}

export function getOrderForm(scode){
  return Vue.http.get(api + 'sales/form/' + scode)
}